import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import qs from "querystring";
import { BASE_SITE, USERS_CHECK_LOGIN_GET } from '../apis';
import { actionLogOutUser, handleChangeProfileData } from '../redux/actions/pages/user/user';
import Root from "./root";


const App = () => {
	
	const dispatch = useDispatch();

	const { token } = useSelector((state: any) => state.user);

	useEffect(() => {
        handleCheckedLoginAndOtherData();
        // eslint-disable-next-line
    }, [App]);

    const handleCheckedLoginAndOtherData = () => {

    	if(token) {

    		axios({
	            method: 'get',
	            url: BASE_SITE + USERS_CHECK_LOGIN_GET,
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'application/x-www-form-urlencoded',
	                'Authorization': token
	            },
	        }).then((response) => {
	            switch (response.data.status) {
	                case 're_login':
	                    dispatch(actionLogOutUser());
	                    break;
	                case 'ok':
                        if(response.data.info !== undefined) 
                            dispatch(handleChangeProfileData(response.data.info));
	                    break;
	                default:

	                    break;
	            }
	        });    		
    	}
    };

	return (
        <div id={'app'} className={'rtl'}>
            <Root/>
        </div>
    )
}

export default memo(App);
